export const GET_CONTENT_ANALYSIS = 'GET_CONTENT_ANALYSIS'
export const GET_CONTENT_ANALYSIS_SUCCESS = 'GET_CONTENT_ANALYSIS_SUCCESS'

export const UPDATE_CONTENT_ANALYSIS = 'UPDATE_CONTENT_ANALYSIS'
export const UPDATE_CONTENT_ANALYSIS_SUCCESS = 'UPDATE_CONTENT_ANALYSIS_SUCCESS'

export const CONTENT_ANALYSIS_PAGE_KEYWORDS = 'CONTENT_ANALYSIS_PAGE_KEYWORDS'
export const CONTENT_ANALYSIS_PAGE_KEYWORDS_SUCCESS = 'CONTENT_ANALYSIS_PAGE_KEYWORDS_SUCCESS'

export const GET_CONTENT_ANALYSIS_ERROR = 'GET_CONTENT_ANALYSIS_ERROR'